import stickybits from 'stickybits';
import scrollTo from './modules/smoothscroll.js';

const productFeatureOption = Array.from(
  document.querySelectorAll('.js-productFeatureOption')
);

const productNav = Array.from(document.querySelectorAll('.js-productNav'));

stickybits('.js-sticky', {
  useFixed: true,
  stickyBitStickyOffset: 150,
});

const links = document.querySelectorAll('.js-productNav');

if (links.length) {
  scrollTo(links);
}

window.addEventListener('scroll', () => {
  const scrollPosition = window.scrollY;
  let ticking;

  if (!ticking) {
    window.requestAnimationFrame(() => {
      productNav.forEach(function highlightLink(navLink) {
        const dataNav = navLink.getAttribute('data-nav');
        const associatedElement = document.querySelector(
          `.js-productFeatureOption[data-nav="${dataNav}"]`
        );

        if (
          associatedElement.offsetTop <= scrollPosition &&
          associatedElement.offsetTop + associatedElement.clientHeight > scrollPosition
        ) {
          navLink.classList.add('-active');
        } else {
          navLink.classList.remove('-active');
        }
      });
      ticking = false;
    });

    ticking = true;
  }
});
